import * as React from "react";
import { ColumnHelper } from "@tanstack/react-table";
import _ from "lodash";

import { Text } from "src/library/components/Text";
import {
  IList,
  IListLine
} from "src/core/lists/api/lists.api";

/**
 * This function returns a reusable formated column definition for list quantity data to be used in Tanstack tables
 *
 * @param columnHelper
 * @returns column definition for list quantity data
 */
export const listQuantityColumn = (
  columnHelper: ColumnHelper<IList>
) => {
  return columnHelper.accessor("listLines", {
    id: "quantity",
    header: "Quantity",
    cell: info => {
      const listLines: IListLine[] = info.getValue();

      if (listLines) {
        return (
          <Text>
            {_.sumBy(listLines, listLine => listLine.quantity)}
          </Text>
        );
      } else {
        return null;
      }
    },
    enableSorting: false,
    enableColumnFilter: false,
    minSize: 70,
    meta: { style: { align: "right" } }
  });
};
